import { BsQuestion } from '@react-icons/all-files/bs/BsQuestion';
import { BsShield } from '@react-icons/all-files/bs/BsShield';
import { BsHouse } from '@react-icons/all-files/bs/BsHouse';
import { FaCheck } from '@react-icons/all-files/fa/FaCheck';
import { GiSteeringWheel } from '@react-icons/all-files/gi/GiSteeringWheel';
import { HiClipboardList } from '@react-icons/all-files/hi/HiClipboardList';
import { ProgressStatus, STEP } from '@insurgrid/common';
import { Progress } from '../types';

export const CLIENT_ID_KEY = 'client_id';
export const SUBMISSION_ID = 'submissionId';
export const SHOW_EXTRACTED_DATA_STORAGE_KEY = 'show-extracted-data';

export const PROGRESS: Progress = [
  // {
  //   step: STEP.personal,
  //   name: 'Contact details',
  //   helperText:
  //     'Provide us with your name and email so we can deliver you a quote.',
  //   status: ProgressStatus.Upcoming,
  //   icon: BsPerson,
  // },
  {
    step: STEP.submission,
    name: 'Current insurance carriers',
    helperText:
      "Let's get your current policy information. It's never been this easy!",
    status: ProgressStatus.Upcoming,
    icon: BsShield,
  },
  {
    step: STEP.driver,
    name: 'Drivers',
    helperText:
      'We would like to know about any drivers covered by your policy.',
    status: ProgressStatus.Upcoming,
    icon: GiSteeringWheel,
  },
  {
    step: STEP.property,
    name: 'Properties',
    helperText:
      'Whether you rent or own, please tell us a little bit about your properties.',
    status: ProgressStatus.Upcoming,
    icon: BsHouse,
  },
  {
    step: STEP.agentQuestions,
    name: 'Agent questions',
    helperText: 'Your agent is requesting additional information.',
    status: ProgressStatus.Upcoming,
    icon: BsQuestion,
  },
  {
    step: STEP.summary,
    name: 'Summary',
    helperText: 'Please review the information you have provided.',
    status: ProgressStatus.Upcoming,
    icon: HiClipboardList,
  },
  {
    step: STEP.finished,
    name: 'Finished',
    helperText:
      'Good job, thank you for going through the fantastic InsurGrid process.',
    status: ProgressStatus.Upcoming,
    icon: FaCheck,
  },
];
